import { Box, BoxProps } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'

interface IssueTimelineItemProps extends BoxProps {
	isFirst?: boolean
	isLast?: boolean
}
const IssueTimelineItem = ({ isFirst, isLast, children, ...props }: IssueTimelineItemProps) => {
	const getBorderHeightValue = () => {
		if (isFirst) {
			return `calc(100% - ${pxToRem(6)})`
		}
		if (isLast) {
			return pxToRem(6)
		}
		return '100%'
	}
	return (
		<Box
			pl={pxToRem(20)}
			pb={pxToRem(16)}
			{...props}
			sx={{
				position: 'relative',
				'&::before': {
					content: '""',
					width: '1px',
					height: getBorderHeightValue(),
					background: color.colGray3,
					position: 'absolute',
					top: isFirst ? pxToRem(6) : 0,
					left: pxToRem(4),
				},
				'&::after': {
					content: '""',
					width: pxToRem(6),
					height: pxToRem(6),
					borderRadius: '100px',
					background: color.colMintBlue,
					position: 'absolute',
					left: pxToRem(1.5),
					top: pxToRem(6),
				},
			}}
		>
			{children}
		</Box>
	)
}
export default IssueTimelineItem
